import { FC } from "react";

interface GallerySlideProps {
    index: number;
}

const GallerySlide: FC<GallerySlideProps> = (props) => {
    return (
        <div className="flex flex-col mr-4 ti7:mr-3 tmax4:mr-1 dmin2:h-[495px] di8:h-[460px] di7:h-[420px] ti3:h-[420px] td8:h-[380px] ti7:h-[350px] ti8:h-[480px] mi2:h-[495px] mi1:h-[495px] mi5:h-[420px]">
            <img
                src={`images/gallery/gallery-${props.index}.jpg`}
                alt={`market-${props.index}`}
                className="w-full h-full object-cover rounded-[2px]"
            />
        </div>
    );
};

export default GallerySlide;
